import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=2dff2c7e&scoped=true"
import script from "./Registry.vue?vue&type=script&lang=js"
export * from "./Registry.vue?vue&type=script&lang=js"
import style0 from "./Registry.vue?vue&type=style&index=0&id=2dff2c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff2c7e",
  null
  
)

export default component.exports